<template>
  <div class="fi-plan-board" style="margin:20px">

    <FiPageRail v-if="!standalone" title="Planned - Driver Utilization Monthly">
      <template #actions>
        <span style="float:right; margin-right: 10px; font-weight: bold; font-size: 18px;"><a target="_blank" :href="'./#/driver-util-monthly-cm/' + tenant_id">standalone mode</a></span>
      </template>
    </FiPageRail>
    <div v-if="standalone">
      <span style="font-size: 20px; font-weight: bold; margin-bottom: 10px;" class="d-flex align-items-center justify-content-center">
        <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img style="margin-top:-5px" width="40" src="favicon.ico"/></a>&nbsp;Driver Utilization Monthly&nbsp;
      </span>
    </div>

    <div style="position: relative; font-size: 20px; font-weight: bold;" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;|&nbsp;&nbsp;Overnight Offset: &nbsp;<b-form-select v-model="selected_hours_offset" :options="hours_offset_options" style="font-size: 18px; font-weight: bold; width:100px"/>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-form-select v-model="driver_mode" :options="driver_mode_options" style="font-weight: bold;width:110px"></b-form-select>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-button size="md" variant="success" @click="download">Download</b-button>
    </div>
    <br/>
    <div v-if="!loading">
      <div v-if="summary.driver_type_stats && summary.driver_type_stats.length" class="row" style="margin:10px; font-weight: bold; font-size: 16px;">
        <template v-for="(type_stat, idx) in summary.driver_type_stats">
          <div v-if="selected_types.indexOf(type_stat.type) > -1" @click="filter_by_type(type_stat.type)" class="col" :style="{ 'background': type_stat.color, 'border': '2px solid red' }">{{type_stat.total_cnt}} - {{type_stat.type}} [{{month_total_for_type(type_stat)}}]</div>
          <div v-else @click="filter_by_type(type_stat.type)" class="col" :style="{ 'background': type_stat.color }">{{type_stat.total_cnt}} - {{type_stat.type}} ({{month_total_for_type(type_stat)}})</div>
        </template>
      </div>
      <br/>
      <template v-for="chunk in items">
        <div class="align-right d-flex justify-content-center" style='display: flex; flex-wrap: nowrap'>
          <template v-if="driver_mode=='available'">
            <div style="max-width: 250px; min-width: 250px !important; border: 1px solid black; margin-top:5px" v-for="(day_record,day_idx) in chunk">
              <div style="background-color: #ddd; border-bottom: 2px solid black;font-weight: bold; font-size:22px; text-align:center">{{day_record.date_month}}/{{day_record.date_day}} - {{day_record.date_weekday}}</div>
              <div style="background-color: #eee; font-weight: bold; font-size:16px; text-align:center">{{get_day_total(day_record)}} Total</div>
              <template v-if="!day_record.subtype_cnts && (selected_types.length == 0 || selected_types.indexOf(type_cnt.type) != -1)" v-for="type_cnt in day_record.type_cnts">
                <div style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForDriverID(type_cnt.colorcode)' v-on:click="toggle_div(type_cnt,'isDriversVisible')"><b>{{type_cnt.type}} [{{type_cnt.available_cnt}}]</b></div>
                <div :style="type_cnt.isDriversVisible ? 'background: hsla(120,100%,75%,0.1); border: 1px dotted darkgrey; margin: 5px 5px 5px 25px;' : 'display:none'" v-if="item.driver_type == type_cnt.type" v-for="(item, idx) in day_record.available">
                    <b>{{item.driver_name}}</b>
                </div>
              </template>
              <template v-if="day_record.subtype_cnts && (selected_types.length == 0 || selected_types.indexOf(type_cnt.type) != -1)" v-for="type_cnt in day_record.type_cnts">
                <div style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForDriverID(type_cnt.colorcode)' v-on:click="toggle_div(type_cnt,'isSubtypesVisible')"><b>{{type_cnt.type | trim(20)}} [{{type_cnt.available_cnt}}]</b></div>
                <span :style="type_cnt.isSubtypesVisible ? '' : 'display:none'" v-if="subtype.parent_type === type_cnt.type" v-for="(subtype, idx) in day_record.subtype_cnts">
                    <div style="padding: 4px; margin: 5px 5px 5px 15px; font-size: 14px" :style='getStyleForDriverID(type_cnt.colorcode)' v-on:click="toggle_div(subtype,'isDriversVisible')">
                      <b>{{subtype.type}} [{{subtype.available_cnt}}]</b>
                    </div>
                    <div :style="subtype.isDriversVisible ? 'background: hsla(120,100%,75%,0.1); border: 1px dotted darkgrey; margin: 5px 5px 5px 25px;' : 'display:none'" v-if="assn.driver_subtype === subtype.type" v-for="(assn, idx) in day_record.available">
                      <b>{{assn.driver_name}}</b>
                    </div>
                </span>
                <span :style="type_cnt.isSubtypesVisible ? '' : 'display:none'" v-if="!type_exists(type_cnt.type,day_record.subtype_cnts) && assn.driver_type == type_cnt.type" v-for="(assn, idx) in day_record.available">
                  <div @click="toggle_div(assn,'isVisible')" style="background: hsla(120,100%,75%,0.1); border: 1px dotted darkgrey; margin: 5px 5px 5px 25px;">
                    <b>{{assn.driver_name}}</b>
                  </div>
                </span>
              </template>
            </div>
          </template>
          <template v-else>
            <div style="max-width: 250px; min-width: 250px !important; border: 1px solid black; margin-top:5px" v-for="(day_record,day_idx) in chunk">
              <div style="background-color: #ddd; border-bottom: 2px solid black;font-weight: bold; font-size:22px; text-align:center">{{day_record.date_month}}/{{day_record.date_day}} - {{day_record.date_weekday}}</div>
              <div style="background-color: #eee; font-weight: bold; font-size:16px; text-align:center">{{get_day_total(day_record)}} Total</div>
              <template v-if="!day_record.subtype_cnts && (selected_types.length == 0 || selected_types.indexOf(type_cnt.type) != -1)" v-for="type_cnt in day_record.type_cnts">
                <div style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForDriverID(type_cnt.colorcode)' v-on:click="toggle_div(type_cnt,'isDriversVisible')"><b>{{type_cnt.type}} [{{type_cnt.cnt}}]</b></div>
                <span :style="type_cnt.isDriversVisible ? '' : 'display:none'" v-if="item.driver_type == type_cnt.type" v-for="(item, idx) in day_record.assignments">
                    <div @click="toggle_div(item,'isVisible')" style="border: 1px dotted darkgrey;  margin: 5px 5px 5px 25px;">
                      <span v-if="item.driver_name">
                          <b>{{item.driver_name}}</b>
                      </span>
                      <span v-else>{{item.bookingID}}</span>
                      <div v-if="item.charterID && item.isVisible">
                        <span v-if="item.driver_name"><b>BookingID:</b> {{item.bookingID}}<br/></span>
                        <span v-if="item.driver_name"><b>Driver:</b> {{item.driver_name}}<br/></span>
                        <b>Start:</b> {{item.start_datetime | formatDateTimeSmall}}<br/>
                        <b>Finish:</b> {{item.finish_datetime | formatDateTimeSmall}}
                      </div>
                    </div>
                  </span>
              </template>
              <template v-if="day_record.subtype_cnts && (selected_types.length == 0 || selected_types.indexOf(type_cnt.type) != -1)" v-for="type_cnt in day_record.type_cnts">
                <div style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForDriverID(type_cnt.colorcode)' v-on:click="toggle_div(type_cnt,'isSubtypesVisible')"><b>{{type_cnt.type | trim(20)}} [{{type_cnt.cnt}}]</b></div>
                <span :style="type_cnt.isSubtypesVisible ? '' : 'display:none'" v-if="subtype.cnt > 0 && subtype.parent_type === type_cnt.type" v-for="(subtype, idx) in day_record.subtype_cnts">
                    <div style="padding: 4px; margin: 5px 5px 5px 15px; font-size: 14px" :style='getStyleForDriverID(type_cnt.colorcode)' v-on:click="toggle_div(subtype,'isDriversVisible')">
                      <b>{{subtype.type}} [{{subtype.cnt}}]</b>
                    </div>
                    <span :style="subtype.isDriversVisible ? '' : 'display:none'" v-if="assn.driver_subtype === subtype.type" v-for="(assn, idx) in day_record.assignments">
                      <div @click="toggle_div(assn,'isVisible')" style="border: 1px dotted darkgrey;  margin: 5px 5px 5px 25px;">
                        <span v-if="assn.driver_name">
                            <b>{{assn.driver_name}}</b>
                        </span>
                        <span v-else>{{assn.bookingID}}</span>
                        <div v-if="assn.charterID && assn.isVisible">
                          <span v-if="assn.driver_name"><b>BookingID:</b> {{assn.bookingID}}<br/></span>
                          <span v-if="assn.driver_name"><b>Driver:</b> {{assn.driver_name}}<br/></span>
                          <b>Start:</b> {{assn.start_datetime | formatDateTimeSmall}}<br/>
                          <b>Finish:</b> {{assn.finish_datetime | formatDateTimeSmall}}
                        </div>
                      </div>
                    </span>
                </span>
                <span :style="type_cnt.isSubtypesVisible ? '' : 'display:none'" v-if="!type_exists(type_cnt.type,day_record.subtype_cnts) && assn.driver_type == type_cnt.type" v-for="(assn, idx) in day_record.assignments">
                  <div @click="toggle_div(assn,'isVisible')" style="border: 1px dotted darkgrey;  margin: 5px 5px 5px 25px;">
                    <span v-if="assn.driver_name">
                        <b>{{assn.driver_name}}</b>
                    </span>
                    <span v-else>{{assn.bookingID}}</span>
                    <div v-if="assn.charterID && assn.isVisible">
                      <span v-if="assn.driver_name"><b>BookingID:</b> {{assn.bookingID}}<br/></span>
                      <span v-if="assn.driver_name"><b>Driver:</b> {{assn.driver_name}}<br/></span>
                      <b>Start:</b> {{assn.start_datetime | formatDateTimeSmall}}<br/>
                      <b>Finish:</b> {{assn.finish_datetime | formatDateTimeSmall}}
                    </div>
                  </div>
                </span>
              </template>
            </div>
          </template>
          </div>
        <br/>
      </template>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  </div>

</template>
<script>
import {get_driver_type_calendar, api_url} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'planned_driver_types_monthly_cm',

  components: {
  },

  data() {
    return {
      items: [],
      summary: [],
      loading: false,
      standalone: false,
      driver_mode: 'booked',
      type_mode: 'grouped',
      type_mappings: false,
      selected_hours_offset: '',
      type_mode_options: [
        { text: 'All Types', value: 'all' },
        { text: 'Custom Types', value: 'grouped' },
      ],
      driver_mode_options: [
        { text: 'Booked', value: 'booked' },
        { text: 'Available', value: 'available' },
      ],
      hours_offset_options: [
        { value: '0', text: 'None' },
        { value: '1', text: '1AM' },
        { value: '2', text: '2AM' },
        { value: '3', text: '3AM' },
        { value: '4', text: '4AM' },
        { value: '5', text: '5AM' },
        { value: '6', text: '6AM' },
      ],
      details_fromDate: justDate(moment().startOf('month')),
      details_toDate: justDate(moment().endOf('month')),
      selected_types: [],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
    this.load_data()
  },
  methods: {
    type_exists(type, subtypes) {
      for (const subtype of subtypes){
        if (type === subtype.parent_type)
          return true;
      }
      return false
    },
    async check_features() {
      if (this.$route.path.indexOf('/driver-util-monthly-cm/') == -1) {
        this.standalone = false
        this.tenant_id = this.user.tenant
      }
      else if (this.$route.path.indexOf('/driver-util-monthly-cm/') != -1) {
        this.standalone = true
        this.tenant_id = this.$route.path.split('/driver-util-monthly-cm/')[1]
      }
    },
    filter_by_type(type) {
      let idx = this.selected_types.indexOf(type)
      if (idx > -1) {
        this.selected_types.splice(idx, 1);
      } else {
        this.selected_types.push(type)
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async load_data() {

      this.loading = true
      try {
        const { value: { data = [] }} = await get_driver_type_calendar(this.tenant_id, this.type_mode, this.selected_hours_offset, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.selected_hours_offset = this.summary.hours_offset
        this.type_mappings = this.summary.type_mappings
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    getStyleForDriverID(color) {
      if (color != null)
        return 'border-radius: 10px; background-color:' + color
      return '';
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'month').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'month').endOf('month').format('MM-DD-YYYY');
    },
    get_vis_day_count(assignments)  {
      if (this.selected_types.length == 0)
        return assignments.length;
      else {
        return assignments.filter(item => this.selected_types.indexOf(item.driver_type) != -1).length
      }
    },
    get_day_total(day_record) {
      const list = this.driver_mode === 'booked' ? (day_record.assignments || []) : (day_record.available || [])
      if (this.selected_types.length === 0) return list.length
      return list.filter(item => this.selected_types.indexOf(item.driver_type) !== -1).length
    },
    month_total_for_type(type_stat) {
      if (this.driver_mode === 'booked' && type_stat.booked_month_total != null) return type_stat.booked_month_total
      if (this.driver_mode === 'available' && type_stat.available_month_total != null) return type_stat.available_month_total
      return type_stat.count != null ? type_stat.count : 0
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}

      const tenant_name = this.tenant_id.split('-').length > 1 ? this.tenant_id.split('-')[0] : this.tenant_id
      let filename = `driver-utilization-monthly-${this.driver_mode}-${tenant_name}`
      if (this.selected_types.length > 0) {
        const types_tag = this.selected_types.join('-').replace(/\s+/g, '-').toLowerCase()
        filename += `-${types_tag}`
      }
      filename += `-${this.details_fromDate}-${this.details_toDate}.csv`

      axios.post(
          `${api_url}bookings/reports/planned/driver/utilization/monthly/download`,
          {
            tenant: this.tenant_id,
            type_mode: this.type_mode,
            hours_offset: this.selected_hours_offset,
            fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            driver_mode: this.driver_mode,
            selected_types: this.selected_types.length > 0 ? this.selected_types : null,
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    type_mode(){
      this.selected_types = []
      this.load_data()
    },
    details_toDate() {
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_fromDate = justDate(moment(this.details_toDate, 'MM-DD-YYYY').startOf('month'))

      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 31) {
        this.details_fromDate = moment(this.details_toDate, 'MM-DD-YYYY').subtract(1, 'month').format('MM-DD-YYYY');
      }
    },
    details_fromDate() {
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY')) {
        this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').endOf('month'))
      }

      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 31) {
        this.details_toDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(1, 'month').format('MM-DD-YYYY');
      }
    },
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
</style>
